import { listaSimNao } from './../shared/listas-parametros';
import { Component, OnInit, Inject } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioSistemaService } from './usuario-sistema.service';
import { UsuarioSistema } from './usuario-sistema.model';
import { UsuarioGrupoService } from '../usuario-grupo/usuario-grupo.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'ntc-usuario-sistema',
  templateUrl: './usuario-sistema.component.html',
  styleUrls: ['./usuario-sistema.component.css']
})
export class UsuarioSistemaComponent implements OnInit {

  loadingVisible = false;
  editOptionsGridUsuarioSistema = null;
  colunasGridUsuarioSistema = null;

  itemsForm = null;
  itemsFormNovo = null;
  itemsFormAlterar = null;

  listaForm = {Id: 'listaGrupoUsuario', status: false};
  listaUsuarioGrupos = null;
  listaSimNao = listaSimNao;

  usuarioSistema: UsuarioSistema;
/*
  usuarioSistema = {
    Id: null,
    Nome: null,
    Login: null,
    Senha: null,
    Grupos: []
  };
*/
  constructor(
    @Inject(Http) http: Http,
    private route: ActivatedRoute,
    private router: Router,
    private usuarioSistemaService: UsuarioSistemaService,
    private usuarioGrupoService: UsuarioGrupoService
  ) {
    this.loadingVisible = true;

    this.usuarioSistema = new UsuarioSistema;

    // carrega a lista de UsuarioGrupo
    this.usuarioGrupoService.getUsuarioGrupos()
      .subscribe(usuarioGrupos => {
        this.listaUsuarioGrupos = usuarioGrupos;
        this.loadingVisible = false;
      },
      error => {
        this.loadingVisible = false;
      }
    );

    this.itemsFormNovo = [
      {
        dataField: 'Id',
        editorType: 'dxTextBox',
        label: { text: 'ID' },
        editorOptions: { disabled: true }
      },
      {
        dataField: 'Nome',
        editorType: 'dxTextBox',
        label: { text: 'Nome' },
        editorOptions: {},
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório.'
        }]
      },
      {
        dataField: 'Login',
        editorType: 'dxTextBox',
        label: { text: 'Login' },
        editorOptions: {},
        validationRules: [{
          type: 'required',
          message: 'Login é obrigatório.'
        }]
      },
      {
        dataField: 'Senha',
        editorType: 'dxTextBox',
        label: { text: 'Senha' },
        editorOptions: {
          mode: 'password'
        },
        validationRules: [{
          type: 'required',
          message: 'Senha é obrigatório.'
        }]
      },
      {
        editorType: 'dxTextBox',
        label: { text: 'Confirmar Senha' },
        editorOptions: {
          mode: 'password'
        },
        validationRules: [{
          type: 'compare',
          message: 'Confirmar senha é obrigatório. Informar mesmo valor inserido em campos Senha',
          comparisonTarget: this.confirmarSenha,
        }]
      }
    ];

    this.itemsFormAlterar = [
      {
        dataField: 'Id',
        editorType: 'dxTextBox',
        label: { text: 'ID' },
        editorOptions: { disabled: true }
      },
      {
        dataField: 'Nome',
        editorType: 'dxTextBox',
        label: { text: 'Nome' },
        editorOptions: {},
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório.'
        }]
      },
      {
        dataField: 'Login',
        editorType: 'dxTextBox',
        label: { text: 'Login' },
        editorOptions: {},
        validationRules: [{
          type: 'required',
          message: 'Login é obrigatório.'
        }]
      },
      {
        dataField: 'SuperUsuario',
        editorType: 'dxSelectBox',
        label: { text: 'Super Usuário' },
        editorOptions: { items: this.listaSimNao, displayExpr: 'Descricao', valueExpr: 'Id' },
        validationRules: [{
          type: 'required',
          message: 'Super Usuário é obrigatório.'
        }]
      }
    ];

  }

  gravar = function(params: any) {
    let result = params.validationGroup.validate();

    if (this.usuarioSistema.Grupos.length === 0) {
      notify('Grupo de Usuário não foi informado!', 'error', 2000);
      result.isValid = false;
    }

    if (result.isValid) {
      this.sResultado = 'Válido!';

      this.usuarioSistemaService.gravarUsuarioSistema(this.usuarioSistema)
        .subscribe((ret: UsuarioSistema) => {
          notify(`Usuário gravado com sucesso! ${ret.Id}`, 'success', 2000);
          this.router.navigate(['/usuarios-sistema']);
        },
        error => {
          notify(`Erro ao gravar Usuário`, 'error', 2000);
        });

    } else {
      this.sResultado = 'Inválido!';
    }

    this.isPopupVisible = !this.isPopupVisible;
  };

  confirmarSenha = () => this.usuarioSistema.Senha; // Funcao para validar confirmacao de senha

  ngOnInit() {
    if (this.route.snapshot.params['id'] !== undefined) {
      this.usuarioSistemaService.getUsuarioSistemaById(this.route.snapshot.params['id'])
        .subscribe(usuarioSistema => {
          this.usuarioSistema = usuarioSistema;
          this.itemsForm = this.itemsFormAlterar;
        });
    } else {
      this.itemsForm = this.itemsFormNovo;
    }
  }

  onCellPrepared = function(e){
    adicionaIconesGrid(e);
  }

}



// WEBPACK FOOTER //
// ./src/app/usuario-sistema/usuario-sistema.component.ts